export default {"src":"/_next/static/media/peaceOfMind_24.6c61e384.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};